import type { FC } from 'react';

import { useIntl } from 'react-intl';
import { Button, Modal } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

import type { PlanMonthlyJourneyUnderMinImpact } from '../types';
import styles from '../styles.module.less';

type Props = {
  open: boolean;
  impact: PlanMonthlyJourneyUnderMinImpact | null;
  onConfirm: () => void;
  onCancel: () => void;
};

export const PlanMonthlyJourneyUnderMinModal: FC<Props> = ({
  open,
  impact,
  onConfirm,
  onCancel,
}) => {
  const intl = useIntl();

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      closable={false}
      destroyOnClose
      width={480}
      className={styles.modal}
      title={intl.formatMessage({ id: 'workJourney.management.plan.underMin.title' })}
      footer={null}
    >
      <p>
        {impact
          ? intl.formatMessage(
              { id: 'workJourney.management.plan.underMin.message' },
              {
                user: impact.userDisplayName,
                journey: impact.journeyName,
                remaining: impact.remainingMembers,
                required: impact.requiredMembers,
              },
            )
          : null}
      </p>
      <div className={styles.successActions}>
        <Button type="primary" onClick={onConfirm} block>
          <IntlMessages id="workJourney.management.plan.underMin.assignAnyway" />
        </Button>
        <Button onClick={onCancel} block>
          <IntlMessages id="general.cancel" />
        </Button>
      </div>
      <p className={styles.footnote}>
        <IntlMessages id="workJourney.management.plan.underMin.footnote" />
      </p>
    </Modal>
  );
};
